import React from 'react';
import '../../assets/css/elements/feature_item.css';

const FeatureItem = ({ icon, title, description, link }) => {
    return (
        <div className="feature-item" onClick={() => link && (window.location = link)}>
            <div className="feature-icon">
                {icon}
            </div>
            <h3 className="feature-title">{title}</h3>
            <p className="feature-description">{description}</p>
        </div>
    );
};

export default FeatureItem;